import React, { useState, useEffect } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import UpperNavbar from '../Dashboard/UpperNavbar'
import { useNavigate } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Country,getStatesOfCountry,getCitiesOfState } from 'country-state-city';

function Step3() {
  const navigate = useNavigate()
  const [addressLine1, setAddressLine1] = useState('')
  const [addressLine2, setAddressLine2] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [pincode, setPincode] = useState('')
  const [studentData, setStudentData] = useState({})
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  
  const [open, setOpen] = React.useState(false);

  // LOADER START
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  // LOADER END

  // USER AUTHENTICATION
  const userAuthenticationData = async () => {
    fetch('/user-authentication-data')
      .then(response => response.json())
      .then(data => {
        setStudentData(data)
        if (data.pincode) {
          setPincode(data.pincode)
          setAddressLine1(data.addressLine1)
          setAddressLine2(data.addressLine2)
          setState(data.state)
          setCity(data.city)
          
          // If state exists, load cities for that state
          if (data.state) {
            const stateCities = getCitiesOfState('IN', data.state);
            setCities(stateCities);
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  // UPDATE ADDRESS DETAILS OF USER
  async function updateAddress() {
    setOpen(true)
    const response = await fetch('/adress-update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId: studentData._id,
        addressLine1,
        addressLine2,
        city,
        state,
        pincode
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "changes successfully") {
          setOpen(false)
          navigate('/fillApplication-step4')
        }
        else {
          setOpen(false)
          alert('Error')
        }
      })
  }

  // Handle state change
  const handleStateChange = (e) => {
    const selectedStateCode = e.target.value;
    setState(selectedStateCode);
    setCity(''); // Reset city when state changes
    
    // Get cities for selected state
    if (selectedStateCode) {
      const stateCities = getCitiesOfState('IN', selectedStateCode);
      setCities(stateCities);
    } else {
      setCities([]);
    }
  }

  // Handle city change
  const handleCityChange = (e) => {
    setCity(e.target.value);
  }

  useEffect(() => {
    userAuthenticationData();
    
    // Load Indian states on component mount
    const indianStates = getStatesOfCountry('IN');
    setStates(indianStates);
  }, [])

  return (
    <div className='paymentPage'>
      <UpperNavbar />
      <h2 className='applicationCSS4 text-center pt-2 text-black font-bold'>PG Application Form 2023 (MBA/PGDM)</h2>
      <div className='applicationCSS3'>
        <img className='fluid applicationCSS2' style={{ margin: 'auto' }} src="https://ucarecdn.com/e853544e-4a83-4196-9e8d-4fe7520ca2f4/step3.png" alt="" />
      </div>

      {/* ********************************   form                **************************** */}
      <div className='p-4 bg-white bootstrap-form applicationCSS' >
        <form className="row g-3">
          <div className="col-md-12 ">
            <label htmlFor="inputEmail4" className="form-label text-black font-bold">Address Line 1</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 1' 
              style={{ outline: 'none' }} 
              type="text" 
              value={addressLine1} 
              onChange={(e) => { setAddressLine1(e.target.value) }} 
              className="form-control shadow-none text-black" 
              id="inputEmail4" 
            />
          </div>
          <div className="col-md-12">
            <label htmlFor="inputPassword4" className="form-label text-black font-bold">Address Line 2</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 2' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={addressLine2} 
              onChange={(e) => { setAddressLine2(e.target.value) }} 
              id="inputPassword4" 
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="inputCountry" className="form-label text-black font-bold">Country</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              disabled 
              placeholder='Country' 
              type="text" 
              className="cursor-not-allowed form-control shadow-none text-black" 
              value="India" 
              id="inputCountry" 
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="inputState" className="form-label text-black font-bold">State</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="inputState"
              className="form-control shadow-none text-black"
              value={state}
              onChange={handleStateChange}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.isoCode} value={state.isoCode}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor="inputCity" className="form-label text-black font-bold">City</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="inputCity"
              className="form-control shadow-none text-black"
              value={city}
              onChange={handleCityChange}
              disabled={!state}
            >
              <option value="">Select City</option>
              {cities.map((city) => (
                <option key={city.name} value={city.name}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor="inputPincode" className="form-label text-black font-bold">Pincode</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Enter Your Pincode' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={pincode} 
              onChange={(e) => { setPincode(e.target.value) }} 
              id="inputPincode" 
            />
          </div>
        </form>
        <div className="col-12 flex justify-between flex-row-reverse mt-2">
          <button 
            disabled={!addressLine1 || !addressLine2 || !city || !state || !pincode} 
            onClick={updateAddress} 
            className="btn btn-primary"
          >
            Save & Continue
          </button>
          <button 
            onClick={() => { navigate('/fillApplication-step2') }} 
            className="btn btn-primary"
          >
            Back
          </button>
        </div>
      </div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default Step3